import React, { useState, useRef, useEffect, useCallback } from "react";
import FeedbackAnalysisGrid from "./Grids/FeedbackAnalysisGrid";
// import courseData from './mockData.json';
import ReportsFilter from "./ReportsFilter";
// import Year from '../Calendar/Year';

const FeedbackAnalysis = () => {
    const [selectedYear, setSelectedYear] = useState();
    const [selectedCustomerCodeInfo, setSelectedCustomerCodeInfo] = useState("Customer Code");

    const handleCustomerCodeChange = (custCode) => {
        setSelectedCustomerCodeInfo(custCode);
    }

    const handleYearChange = (year) => {
        setSelectedYear(year);
    }

    const handleAddTraining = () => {
        setShowTrainingForm(true);
    }

    return (
        <>
            <div className="w-full sm:w-12/12 px-28 py-8">
                <ReportsFilter handleAddTraining={handleAddTraining} handleYearChange={handleYearChange} hideForecastButton={true} hideAddButton={false} handleCustomerCodeChange={handleCustomerCodeChange} />
            </div>
            <div className="grid grid-cols-1 gap-16 px-24 pt-8">
                <div className="flex flex-col mt-8 pt-16 rounded-t-xl" style={{ backgroundColor: "#8B6392", textAlign: "center"}}>
                    <h4>FEEDBACK ANALYSIS REPORT - PARTICIPANT WISE</h4>
                </div>
            </div>
            <div className="grid grid-cols-3 gap-16 p-24">
                <div className="flex col-span-2 flex-col mt-16 rounded-2xl">
                    <FeedbackAnalysisGrid answer={false} other={false} />
                </div>
                <div className="flex flex-col mt-8 rounded-xl">
                    <FeedbackAnalysisGrid answer={true} other={false} />
                </div>
            </div>
            <div className="grid grid-cols-1 gap-16 p-24">
                <div className="flex flex-col mt-8 rounded-xl">
                    <FeedbackAnalysisGrid answer={false} other={true}/>
                </div>
                <div className="flex flex-col mt-8 rounded-xl">
                    <FeedbackAnalysisGrid answer={false} other={true}/>
                </div>
            </div>
            {/* <div style={{ borderTop: "1px solid #FFFFFF", margin: "20px 20px" }}></div> */}
        </>
    )
}

export default FeedbackAnalysis;